import { useDismissAllMessagesMutation } from "../../api/apiSlice";

export const NukeView = () => {
  const [dismissAllMessages, { isLoading }] = useDismissAllMessagesMutation();

  const onNukeMessagesClicked = async () => {
    if (!isLoading) {
      try {
        await dismissAllMessages().unwrap();
      } catch (err) {
        console.error("Failed to save the post: ", err);
      }
    }
  };
  return (
    <div className="row text-light">
      <hr />
      <h3 className="text-light">Dismiss All</h3>
      <p>
        This button will dismiss all messages, Super Chats, and new member
        notifications. This should only be used prior to starting a new even to
        get rid of old messages if the bot wasn't stopped.
      </p>
      <div className="d-md-block">
        <button
          type="button"
          className="btn btn-danger"
          onClick={onNukeMessagesClicked}
        >
          Dismiss All
        </button>
      </div>
    </div>
  );
};
